import { render } from "./Tabs.vue?vue&type=template&id=c2751860&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"

import "./Tabs.vue?vue&type=style&index=0&id=c2751860&scoped=true&lang=css"

import exportComponent from "D:\\Git\\Nakhoncity\\Nakhoncity-App-Queue-Idcard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2751860"]])

export default __exports__